import { DeepReadonlyObject } from 'rxdb';

import { ItineraryView } from '@mopla/data-models';
import { getTripType } from '@mopla/utils';

import { deriveRideHailingLabels } from './deriveRideHailingLabels';

export const deriveRideHailingViewModel = (
	itinerary: DeepReadonlyObject<ItineraryView>
) => {
	const legs = itinerary.legs ?? [];

	const tripType = getTripType(legs);

	const labels = deriveRideHailingLabels(legs);

	const isMixedTrip =
		tripType === 'KR' ||
		tripType === 'RK' ||
		tripType === 'KRK' ||
		tripType === 'LBT';

	const shouldShowLabels = isMixedTrip;

	return {
		labels,
		shouldShowLabels,
	};
};
